import Api from './Api'

export default {
  getUsers() {
    return Api().get('/user')
  },
  saveUser(data) {
    return Api().put('/user', data)
  }
}